import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { withProcedureWraper } from '../..'
import { Routes } from '../../../../AppRoutes'
import { Box } from '../../../../components/box'
import { Icon } from '../../../../components/icon'
import { Table } from '../../../../modules/table'
import { LeaveRequestService } from '../../../../services/leave-request/leaveRequest.service'
import { useSelector } from '../../../../store/store'
import { getDDMMYYYFormat } from '../../../../helper/dateTimeHelper'
import * as _ from "lodash";
import { requestStatus } from '../../../../constants/statusConstants'
import ApprovalStatus from '../../../../components/status/approvalStatus'

const totalLeaeRequest = 12;

export const procedureApplicationForLeave: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector(state => state.user);
  const currentUserName = user?.current?.username;
  const [approvedRequest, setApprovedRequest] = useState(0);
  const [remainingRequest, setRemainingRequest] = useState(0);
  const [waitingRequest, setWaitingRequest] = useState(0);

  const getLeaveRequestsNeedMeApprove = () => {
    return LeaveRequestService.getLeaveRequestsNeedMeApprove(currentUserName, requestStatus.submitted).then(res => {
      return { data: _.reverse(res), count: res.length }
    }, error => {
      return { data: [], count: 0 }
    });
  }

  const getMyLeaveRequests = () => {
    return LeaveRequestService.getMyLeaveRequests(currentUserName).then(res => {
      const approvedReqs = res.filter((o: any) => o.fields.eRquestStatus === requestStatus.approved).length;
      const waitingReqs = res.filter((o: any) => o.fields.eRquestStatus === requestStatus.submitted).length;
      const remainingReqs = totalLeaeRequest - (approvedReqs + waitingReqs);
      setWaitingRequest(waitingReqs);
      setApprovedRequest(approvedReqs);
      setRemainingRequest(remainingReqs);
    }, error => { });
  }

  useEffect(() => {
    if (user) {
      getMyLeaveRequests();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return (
    <div className="LeaveRequestPage">
      <div className="pd15">
        <div className="text-md-center font-weight-bold p-3 bg-info text-white" style={{fontSize:"20px"}}>
            Đơn Xin Nghỉ Phép
        </div>
        <Box
          title="Thống kê nghỉ phép của tôi"
          titleRight={<div className="btnPlus" onClick={() => history.push(Routes.createApplicationForLeave.path.replace(':id', '0'))}>
            <Icon.Plus />Tạo đơn
        </div>}
        >
          <div className="py-4 d-flex justify-content-center">
            <div className="statistic-container">
              <div className="statistic-item left" onClick={() => { history.push(Routes.procedureMyLeaveRequest.path) }}>
                <div className="statistic-number">
                  {approvedRequest}
                </div>
              </div>
              <div className="statistic-text">{'Đã nghĩ'}</div>
            </div>
            <div className="statistic-container">
              <div className="statistic-item approved">
                <div className="statistic-number">
                  {remainingRequest}
                </div>
              </div>
              <div className="statistic-text">{'Còn lại'}</div>
            </div>
            <div className="statistic-container">
              <div className="statistic-item waiting" onClick={() => { history.push(Routes.procedureMyLeaveRequest.path) }}>
                <div className="statistic-number">
                  {waitingRequest}
                </div>
              </div>
              <div className="statistic-text">{'Đang đợi duyệt'}</div>
            </div>
          </div>
          <div className="note-text">
            {'Lưu ý: Click icons để xem chi tiết'}
          </div>
        </Box>
        <Box title="Đơn xin nghỉ nhân viên của tôi"
          titleRight={
            <div className="btnPlus" onClick={() => history.push(Routes.procedureLeaveRequestApprovalHistory.path)}>
              {'Xem lịch sử duyệt'}
            </div>
          }>
          <Table
            onRowClick={(item) => history.push(Routes.procedureLeaveRequestDetail.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Ngày tạo',
                render: (item) => getDDMMYYYFormat(item.createdDateTime)
              },
              {
                name: 'Nhân viên',
                render: (item) => {
                  return `${item.createdBy.user.displayName}`
                }
              },
              {
                name: 'Thời gian nghỉ',
                render: (item) => <span>{
                  `Từ ${getDDMMYYYFormat(item.fields.eLeaveStartDate)} Đến ${getDDMMYYYFormat(item.fields.eLeaveEndDate)}`
                }
                </span>
              },
              {
                name: 'Tổng số ngày nghỉ',
                render: (item) => item.fields.eDuration
              },
              {
                name: 'Loại',
                render: (item) => item.fields.eLeaveType
              },
              {
                name: 'Lý do',
                render: (item) => item.fields.eLeaveReason
              },
              {
                name: 'Quyết định',
                render: (item) => <ApprovalStatus status={item.fields.eRquestStatus} />
              }
            ]}
            onFetchData={getLeaveRequestsNeedMeApprove}
          />
        </Box>
      </div>
    </div>
  )
})